import { type ApolloError, useQuery } from '@apollo/client';
import type { HeaderFooterContextQueryHookResult } from 'src/App/generated/graphql-types';

import { headerFooterQuery } from 'src/queries/headerFooterQuery';
import { getWindowLocation } from 'src/utils/window';

export const useHeaderFooterData = (): {
  data?: HeaderFooterContextQueryHookResult['data'];
  error?: ApolloError;
  isLoading: boolean;
} => {
  const { search, pathname } = getWindowLocation();

  const { data, error, loading, previousData } = useQuery(headerFooterQuery, {
    variables: {
      input: { location: { pathname, search } },
    },
  });

  return {
    data: loading && previousData ? previousData : data,
    isLoading: loading,
    error,
  };
};
